var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageAlt2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M0 11.603V15a3 3 0 0 0 3 3h12a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3H3a3 3 0 0 0-3 3v8.479l-.062.07.062.054ZM15 1.5H3A1.5 1.5 0 0 0 1.5 3v6.783l2.46-2.78a.75.75 0 0 1 1.149.031l4.436 5.6 3.638-3.348a.75.75 0 0 1 .983-.029l2.334 1.91V3A1.5 1.5 0 0 0 15 1.5Zm1.5 11.605V15a1.5 1.5 0 0 1-1.5 1.5H3A1.5 1.5 0 0 1 1.5 15v-2.953l2.99-3.38L8.87 14.2a.75.75 0 0 0 1.097.086l3.753-3.455 2.78 2.275Z",
    clipRule: "evenodd",
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(-1 0 0 1 12.858 3.6)",
    fill: "currentColor",
    className: "accent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageAlt2);
export default __webpack_public_path__ + "static/media/image-alt-2.d6a116180ea462658f9b6afb30a9ff14.svg";
export { ForwardRef as ReactComponent };